



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Project } from '@/data/projects.ts';
import SystemLink from '@/components/SystemLink.vue';

@Component({ components: { SystemLink } })
export default class ProjectCard extends Vue {
  @Prop() public project!: Project;
}
